/**
 * @generated SignedSource<<e731c73daa3a4aec33ba4801f79f5543>>
 * @relayHash 35cdd10bfcb6c0124f988dd9e3d183e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa

import type { ConcreteRequest } from 'relay-runtime';
export type CsmAiWidgetBrandingChatColorVibeVariant = "DARK" | "DEFAULT" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingColorVibeVariant = "DARK" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingRadius = "NORMAL" | "ROUNDED" | "SHARP" | "%future added value";
export type CsmAiWidgetBrandingSpaceVariant = "COMFORTABLE" | "COSY" | "GENEROUS" | "%future added value";
export type CsmAiWidgetPosition = "CENTER" | "CORNER" | "%future added value";
export type supportWidgetConfigProviderQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type supportWidgetConfigProviderQuery$data = {
  readonly csmAi_getSupportWidget: {
    readonly id?: string;
    readonly isEnabled?: boolean | null;
    readonly position?: CsmAiWidgetPosition;
    readonly theme?: {
      readonly chatColor: CsmAiWidgetBrandingChatColorVibeVariant;
      readonly colorVibeVariant: CsmAiWidgetBrandingColorVibeVariant;
      readonly radius: CsmAiWidgetBrandingRadius;
      readonly space: CsmAiWidgetBrandingSpaceVariant;
    } | null;
  } | null;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly helpCenterBranding?: {
        readonly colors: {
          readonly primary: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type supportWidgetConfigProviderQuery = {
  response: supportWidgetConfigProviderQuery$data;
  variables: supportWidgetConfigProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpCenterBranding",
      "kind": "LinkedField",
      "name": "helpCenterBranding",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "primary"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "position"
    },
    {
      "concreteType": "CsmAiWidgetBrandingTheme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorVibeVariant"
        },
        {
          "kind": "ScalarField",
          "name": "radius"
        },
        {
          "kind": "ScalarField",
          "name": "space"
        },
        {
          "kind": "ScalarField",
          "name": "chatColor"
        }
      ]
    }
  ],
  "type": "CsmAiWidgetConfig"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa",
    "metadata": {},
    "name": "supportWidgetConfigProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7afba16f32baf97fd3ce09f41645b442";

export default node;
